// Is this component still being used??
import React from "react";
import { sanitizedData } from "../../../helper_functions/sanitizeData";

class MultilocationSummary extends React.Component {
  render() {
    const { product } = this.props;
    let groupSharedQuantity = 0;
    if (product.groupInfo) {
      groupSharedQuantity = product.groupInfo.sharedInventory.reduce(
        (sum, sharedProduct) => (sum += sharedProduct.quantity),
        0
      );
    }

    return (
      <div className="summaryInfo">
        <strong>{product.name}</strong>
        <p
          dangerouslySetInnerHTML={sanitizedData(product.description)}
        />
        <p> <strong>Quantity Owned</strong></p>
        <label>
          {product.productType === 'addons' ? product.quantity : product.rentableQuantity}
          {product.groupInfo && <span>({groupSharedQuantity})</span>}
        </label>
        {product.productType === 'addons' && (
          <>
            <p>
              <strong>Reserved Pending Checkout</strong>
            </p>
            <label>{product.reservedQuantity ?? 0}</label>
          </>
        )}
        {product.buffer > 0 && (
          <div className="buffer">
            <h6>Buffer</h6>
            <span>
              {Math.round(product.quantity * (product.buffer / 100))} (
              {product.buffer}
              %)
            </span>
          </div>
        )}
        {product.groupInfo && (
          <div className="groupItems">
            <strong>Other Location Quantities</strong>
            {product.groupInfo.sharedInventory.map(
              (sharedProduct, index) =>
                sharedProduct.id !== product.id && (
                  <div key={index}>
                    <strong>{sharedProduct.quantity}</strong>
                    {sharedProduct.locationName}
                    {sharedProduct.locationCode &&
                      " (" + sharedProduct.locationCode + ")"}
                  </div>
                )
            )}
          </div>
        )}
      </div>
    );
  }
}

export default MultilocationSummary;
